<template>
  <div class="service-mp-account-wrapper">
    <i class="avatar" :style="{ backgroundImage: 'url(' + user.avatar + ')' }"/>
    <div class="info">
      <span class="name">大龙和你聊一聊大龙和你聊一聊</span>
      <span class="date">2019-2-14</span>
    </div>
    <ul class="analytic-list">
      <li class="analytic-item">累计收入：<i>0</i>元</li>
      <li class="analytic-item">累计用户：<i>19823</i>人</li>
    </ul>
  </div>
</template>

<script>
import defaultAvatar from '../../assets/default_avatar.png'

export default {
  name: 'MpAccount',
  props: {
    user: Object,
  },
  watch: {
    user: function () {
      if (this.user && !this.user.avatar) {
        this.user.avatar = defaultAvatar
      }
    }
  },
};
</script>

<style scoped lang="scss">
.service-mp-account-wrapper {
  display: flex;
  align-items: center;
  margin: 0 10px 10px 10px;
  padding: 10px 8px;
  border: 1px solid #bbb;
  border-radius: 10px;

  .avatar {
    flex-grow: 0;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
  }

  .info {
    margin: 0 10px;
    width: 0;
    flex-grow: 1;
    flex-shrink: 1;

    .name {
      display: block;
      font-size: 16px;
      color: #101010;
    }

    .date {
      font-size: 12px;
      color: rgba(16, 16, 16, .5);
    }
  }

  .analytic-list {
    min-width: 100px;
    margin: 0;
    padding: 0;
    flex-grow: 0;
    flex-shrink: 0;
    list-style: none;
    text-align: right;

    .analytic-item {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 25px;
      color: #101010;

      i {
        display: inline-block;
        margin-right: 3px;
        font-size: 18px;
        line-height: 25px;
        color: #e51c23;
        font-style: normal;
        vertical-align: bottom;
      }
    }
  }
}
</style>
